'use client'
import { getTransition } from '@/styles'
import { motion } from 'motion/react'
// import { usePathname } from 'next/navigation'
import { ReactNode } from 'react'
import styled from 'styled-components'
import { usePageTransition } from '@/hooks'

interface TransitionWrapperProps {
  children: ReactNode
}

export const TransitionWrapper = ({ children }: TransitionWrapperProps) => {
  // const pathname = usePathname()
  const { transitionName } = usePageTransition()
  
  return (
    <Div key={null} variants={variants} initial='initial' animate={transitionName ?? 'animate'} exit='exit'>
      {children}
    </Div>
  )
}

const Div = styled(motion.div)`
  flex: 1 0 auto;
`

export const PAGE_FADE_OUT_DURATION = 1.5
export const PAGE_FADE_IN_DURATION = .5

const variants = {
  animate: {
    opacity: 1,
    transition: {
      ...getTransition(),
    }
  },
  initial: {
    opacity: 0,
    transition: {
      ...getTransition(.5),
    }
  },
  exit: {
    opacity: 0,
    transition: {
      ...getTransition(.5),
    }
  }
}